<template>
  <section>
    <button
      class="d-none"
      @click="refresh">
      Refresh
    </button>
  </section>
</template>

<script>
import { createWidgetMixin } from 'vue-instantsearch'
const connectRefresh = (
  renderFn,
  unmountFn
) => () => {
  let isActive = false

  return {
    init() {
      isActive = false
      renderFn({ refresh: () => {} }, true)
    },
    render({ instantSearchInstance }) {
      if (instantSearchInstance) {
        isActive = true
        const refresh = () => {
          if (isActive) {
            instantSearchInstance.refresh()
          }
        }
        renderFn({ refresh }, false)
      }
    },
    dispose() {
      isActive = false
      unmountFn()
    }
  }
}

export default {
  name: 'RefreshAlgolia',
  mixins: [createWidgetMixin({ connector: connectRefresh })],
  data() {
    return {
      refreshTimerId: null
    }
  },
  beforeDestroy() {
    if (this.refreshTimerId != null) {
      clearTimeout(this.refreshTimerId)
      this.refreshTimerId = null
    }
  },
  methods: {
    refresh(timeout = true) {
      if (this.refreshTimerId != null) {
        clearTimeout(this.refreshTimerId)
        this.refreshTimerId = null
      }
      if (timeout) {
        this.refreshTimerId = setTimeout(() => {
          this.refreshTimerId = null
          this.state.refresh()
          this.$emit('refresh-done')
        }, 2000)
      } else {
        this.state.refresh()
        this.$emit('refresh-done')
      }
    }
  }
}
</script>
